import { FluentBundle, FluentResource } from '@fluent/bundle'
import { DEFAULT_LOCALE } from '@mote/helpers/constants'
import { getResourceFile } from '@mote/helpers/misc'

async function getMessages(locale) {
  const url = `/locales/${locale}.ftl`
  const response = await fetch(getResourceFile(url))
  return await response.text()
}

export async function generateTranslationBundles(
  preferredLocale = DEFAULT_LOCALE
) {
  if (process.env.NODE_ENV === 'test') return []

  const languagesToProcess = [preferredLocale]

  if (preferredLocale !== DEFAULT_LOCALE) {
    languagesToProcess.push(DEFAULT_LOCALE)
  }

  return Promise.all(
    languagesToProcess.map(async language => {
      let translations = await getMessages(language)

      if (!translations) {
        translations = await getMessages(DEFAULT_LOCALE)
      }

      const bundle = new FluentBundle(language)
      const resource = new FluentResource(translations)
      bundle.addResource(resource)

      return bundle
    })
  )
}
